import { EMBED_OPTIONS, SWITCH_OPTIONS } from "../constants";

const buildQueryParams = (customization = {}, existingQueryParams = {}) => {
  const activeOptions = Object.keys(SWITCH_OPTIONS).reduce((acc, key) => {
    const value = customization[key]?.value;
    if (value) acc[key] = value;

    return acc;
  }, {});

  return { ...existingQueryParams, ...activeOptions };
};

export const buildIframeURL = ({
  previewURL,
  selectedEmbed,
  queryParams,
  customization,
}) => {
  const url = new URL(previewURL);

  const params = buildQueryParams(customization, queryParams);

  Object.entries(params).forEach(([name, value]) => {
    url.searchParams.append(name, value);
  });

  if (
    selectedEmbed === EMBED_OPTIONS.FLOATING_POPUP ||
    selectedEmbed === EMBED_OPTIONS.ELEMENT_POPUP
  ) {
    url.searchParams.set("dynamicHeight", "true");
  }

  return url.toString();
};
